import Error from '../model/Error';
import axios from 'axios';

export default class ListPrefetchedDataRepository {
    static enqueue(listId, notifyUser, formats = null) {
        return new Promise((resolve, reject) => {
            axios
                .put(`/lists/${listId}/enqueue`, { notifyUser, formats })
                .then(() => resolve())
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static checkIfEnqueued(listId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/lists/${listId}/enqueue`)
                .then((data) => resolve(data.data.data))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }
}
